mainApp.directive('phoneConfig', function() {
  return {
      templateUrl: '/public/directives/phoneConfig.html',
      scope: {
          setPhoneNumber: '=',
          presetNumber: '=?',
          onValidationViolation: '=?',
          autoPopulated: '=',
          countryCode: '='
      },
      controller:  ['$scope', '$timeout', '$state' ,'$rootScope',"LocationService", function($scope, $timeout, $state, $rootScope, LocationService) {
          $scope.phoneConfig = {};
          $scope.phoneConfig.countryPrefix;
          $scope.selectedCountry = null;
          /**
           * validating using the pattern given on the field if valid return true else add error to 'phoneConfig'
           * @param field
           * @param message
           * @param pattern
           * @returns {boolean}
           */
          var validate = function (field, message, pattern) {
              var isNum = pattern.test(field);
              if (!isNum) {
                  $scope.$root.errors['phoneConfig'] = message;
                  if($scope.onValidationViolation){
                      $scope.onValidationViolation();
                  }
                  return false;
              }
              else {
                  if ($scope.$root.errors['phoneConfig'] === message) {
                      delete $scope.$root.errors['phoneConfig'];
                  }
                  return true;
              }
          };

          /**
           * validate that phone number is not longer then 20 characters and that all of them are numbers
           * @returns {boolean}
           */
          var phoneNumberValidation = function () {
              var pattern = /^[0-9]{1,20}$/;
              var message = "Phone Number should consist of digits only and be no longer then 20 digits";
              return validate($scope.inPhoneNumber, message, pattern);
          };

          /**
           * validate that the prefix starts with + and consists on other 6 characters which all of them are numbers
           * or spaces
           * @returns {boolean}
           */
          var prefixValidation = function () {
              var pattern = /^\+?[0-9 ]{1,20}$/;
              var message  = "Phone Number prefix may start with '+' but after should consist of digits only e.g. '+1 242'";
              return validate($scope.phoneConfig.countryPrefix, message, pattern);
          };


          /**
           * for supporting the empty number feature we check if both the prefix and the actual number are empty
           * if so we remove any errors found on the phone configuration and validate no more, since we use the trime
           * feature there is no problem with input length
           * @returns {boolean}
           */
          var bothPrefixAndNumberEmptyValidation = function () {
              var pattern = /^$/;
              var isEmpty = pattern.test($scope.inPhoneNumber) && pattern.test($scope.phoneConfig.countryPrefix);
              if(isEmpty)
                  delete $scope.$root.errors['phoneConfig'];
              return isEmpty;
          };

          /**
           * if we auto populate the phone number by default number is valid
           * check all validations found on this directive to state if input is valid
           * @returns {boolean}
           */
          function checkValidity() {
              // no validations needed on auto populated and empty number
              if($scope.autoPopulated == false && !bothPrefixAndNumberEmptyValidation())
                  return prefixValidation() && phoneNumberValidation();
              return true;
          }

          /**
           * since fetching the countries from the server is done asynchronously we provide the service
           * with a callback which will be invoked when the locations are fetched from server
           **/
          function setCountries(countries){
              $scope.countries = countries;

              $scope.updateCountryDropdown();
          }

          function getPrefixFromNumber(number) {
              if (number == null) {
                  return "";
              }

              if ($scope.countries && typeof $scope.countries === "object") {
                  number = number + "";
                  for (var key in $scope.countries) {
                      if ($scope.countries[key].dial_code) {
                          var prefix = $scope.countries[key].dial_code.substr(1);
                          var indexOfPrefix = number.indexOf(prefix);
                          if (indexOfPrefix === 0 || (indexOfPrefix === 1 && number[0] === '+')) {
                              if (number[0] === '+') {
                                  prefix = '+' + prefix;
                              }
                              return prefix;
                          }
                      }
                  }
              }

              return number;
          }

          /**
           * setting a watch on presetNumber in order that when populated by user we will parse and use it,
           * after receiving a first value for preset Number after value changed we remove the watch from
           * the digest cycle of angular
           * @type {*}
           */
          $scope.$watch("presetNumber", function(newVal, oldVal){
              var splicedNumber;
              $scope.selectedCountry = null;
              if (newVal !== oldVal) {
                  if (newVal) {
                      if(!$scope.autoPopulated ){
                          var countryPrefix;

                          splicedNumber = newVal.split('-');

                          if (splicedNumber.length === 1) {
                              countryPrefix = getPrefixFromNumber(splicedNumber[0]);

                              if (countryPrefix !== '' && countryPrefix !== splicedNumber[0]) {
                                  splicedNumber.push(splicedNumber[0].substr(countryPrefix.length));
                              }
                          } else {
                              countryPrefix = splicedNumber[0];
                          }

                          $scope.inPhoneNumber = splicedNumber[1];
                          $scope.updateCountryDropdown();
                          handlePrefix(countryPrefix);
                          if (splicedNumber.length > 2) {
                              for (var i=2;i<splicedNumber.length;i++){
                                  $scope.inPhoneNumber += splicedNumber[i];
                              }
                          }
                      }
                      else{
                          $scope.inPhoneNumber = newVal;
                      }
                  }
                  else{
                      $scope.inPhoneNumber = "";
                      $scope.phoneConfig.countryPrefix = "";
                  }
              }
          });

          /**
           * Updating the Countries dropdown and the country prefix accordingly.
           * In case of selected country by user update the prefix and in case of loading find the country name by the country code from the db.
           */
          $scope.updateCountryDropdown = function(){
              if ($scope.countries){
                  if ($scope.selectedCountry){ // update country prefix
                      $scope.phoneConfig.countryPrefix = $scope.selectedCountry.dial_code;
                      $scope.countryCode = $scope.selectedCountry.code;
                      onPhoneConfigChange();
                  }else{ //auto select by saved country code on the user
                      if ($scope.countryCode){
                          $scope.selectedCountry = $scope.countries[$scope.countryCode];
                      }
                  }
               }
              if ($scope.selectedCountry){
                  if (!bothPrefixAndNumberEmptyValidation()){
                      phoneNumberValidation();
                  }
              }
          }

          /**
           * return a country object represented a select option (selectedCountry) for the first match from countries that have the given prefix
           */
          function getCountryCodeFromPrefix(prefix){
              if (prefix != ""){
                  prefix = (prefix[0] != '+') ? '+' + prefix : prefix;
                  prefix = prefix.replace(/\s/g, '');
                  if ($scope.countries && typeof $scope.countries === "object") {
                      for (var key in $scope.countries) {
                          if ($scope.countries[key].dial_code === prefix) {
                              return $scope.countries[key];
                          }
                      }
                  }
              }

              return null;
          }

          /**
           * populating the prefixes according to the prefix
           *parameter received on function call
           * @param prefix
           */
          function handlePrefix(prefix) {
              if (prefix.indexOf('+') !== 0) {
                  prefix = '+' + prefix;
              }
              $scope.phoneConfig.countryPrefix = prefix;
          }

          /**
           * callback whenever the phone number was changed apply the setPhoneNumber
           * function argument
           **/
          function onPhoneConfigChange(){
              if(bothPrefixAndNumberEmptyValidation()){
                  $scope.setPhoneNumber("");
                  $scope.countryCode="";
              }
              else{
                  $scope.setPhoneNumber($scope.phoneConfig.countryPrefix + '-' + $scope.inPhoneNumber);
              }
          }

          /**
           * since the location service implements a lazy fetching machnizem (only if requested the locations are loaded)
           * we invoke the get locations on startup
           **/
          function init(){
              LocationService.getCountries(setCountries);
          }

          // invocation of getCountries
          init();

          /**
           * on-change function which will check that new input is valud and if so
           * triggers the onPhoneConfigChange function which will triiger a cllabqacck
           */
          $scope.validateAndChange = function () {
              /*
               *  check all validations since validation is done only on ng-change and could be that we have more then
               *  one violation by the inputs
               */
              //in case the selectedCountry is already align with countryPrefix no need to select the country
              if (!$scope.selectedCountry || (typeof $scope.selectedCountry === "object" && $scope.selectedCountry.dial_code && $scope.phoneConfig.countryPrefix != $scope.selectedCountry.dial_code)){
                      $scope.selectedCountry = getCountryCodeFromPrefix($scope.phoneConfig.countryPrefix);
              }

              var isValid = checkValidity();
              if(isValid){
                  onPhoneConfigChange();
              }
          };
      }]
  }
});